import { useDisclosure } from '@chakra-ui/react';
import { createContext, useContext, useRef } from 'react'; // Define the context shape

import { jsx as _jsx } from "react/jsx-runtime";
// Create context with undefined default to enforce provider usage
var SideBarContext = /*#__PURE__*/createContext(undefined); // Provider component

export var SideBarContextProvider = function SideBarContextProvider(_ref) {
  var children = _ref.children;
  var btnRef = useRef(null);
  var sideBarContainerRef = useRef(null);

  var _useDisclosure = useDisclosure(),
      isOpen = _useDisclosure.isOpen,
      onOpen = _useDisclosure.onOpen,
      onClose = _useDisclosure.onClose;

  var value = {
    btnRef: btnRef,
    sideBarContainerRef: sideBarContainerRef,
    isOpen: isOpen,
    onOpen: onOpen,
    onClose: onClose
  };
  return /*#__PURE__*/_jsx(SideBarContext.Provider, {
    value: value,
    children: children
  });
}; // Custom hook to use context safely

export var useSideBarContext = function useSideBarContext() {
  var context = useContext(SideBarContext);

  if (!context) {
    throw new Error('useSideBarContext must be used within a SideBarContextProvider');
  }

  return context;
};